module.exports = __webpack_public_path__ + "img/en.bb773b6c.svg";